/* eslint-disable react/no-array-index-key */

import React from 'react';
import { find } from 'lodash';
import classNames from 'classnames';
import ReactHtmlParser from 'react-html-parser';
// import Swiper from 'react-id-swiper';
import 'react-id-swiper/src/styles/css/swiper.css';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  styled,
  Typography
} from "@material-ui/core";
import { simpleNotification } from '../../utils/notifications';
import { isAuthenticated } from '../../utils/authChecker';
import { localizeIncorrectDate } from '../../utils/dateTime';
import shop from '../../images/shop.png';
import CdkeyBuyModal from './CdkeyBuyModal';
import Counter from './Counter';
import './GameNew.scss';
import {
  getPaymentAmountNew,
  getPlatformImages,
  roundingMoney,
  isQuestOver,
  getLocalTimeString,
  removeHtmlTags,
} from '../../utils/functions';
import Loading from '../loading/Loading';  // 添加导入
import GameGallery from '../quest/GameGallery';
import PromptDialog from "../dialog/PromptDialog";
import OrderConfirmDialog from "../dialog/OrderConfirmDialog";  // 添加导入
// import { Elements } from '@stripe/react-stripe-js';
// import { loadStripe } from '@stripe/stripe-js';
// import StripeCDKCheckoutForm from '../shared/StripeCDKCheckoutForm'; // Import the new form
import { getCardBrandIcon } from '../../utils/cardUtils'; // 移除getDetailedErrorMessage导入
import { validateUserHandshake } from '../../actions/authActions'; // ADD THIS IMPORT
import { getCurCurrencyOfUnit } from "../../utils/util";
// import CloseIcon from "@material-ui/icons/Close";
import StripeDialog from "../shared/StripeDialog";

// 添加默认卡片图标
const defaultCardIcon = getCardBrandIcon('generic');

let platformOptions = [];
// 在文件顶部添加常量定义
const purchaseMethodOptions = [
  { label: 'Buy for yourself', value: 'b' },
  { label: 'Give away', value: 'g' }
];

const paymentMethodOptions = [
  {
    name: 'Noiz Wallet',
    icon: 'wallet-icon',
    value: 'noiz',
  },
  {
    name: 'Credit/Debit Card',
    icon: 'credit-card-icon',
    value: 'stripe',
    imageUrl: defaultCardIcon,
  },
  /*{
    name: 'PayPal',
    icon: 'paypal-icon',
    value: 'paypal',
  }*/
];

// const stripePromise = loadStripe('pk_live_51REgDpI6JENQgpzjwRokyE8RLxp5GbY1S4ojEEy1WUIO2W19yi57AukHbrsiqGKan8yig09PtxvYIZUTdRF3Ekwm00UaMPdxJS');

//const stripePromise = loadStripe('pk_test_51QEmxyFV4wQHDaQmgDo69oUK5es4zGq7jvcKz7JEeJbOqOwYHDqzmcSO1YjDOkadgtUJAjGuHtHU3Y9MP7DM2d0r00oATrNgOj', { betas: ['captcha_challenge_beta_1'] });
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  // '& .MuiDialogContent-root': {
  //   padding: theme.spacing(2),
  // },
  // '& .MuiDialogActions-root': {
  //   padding: theme.spacing(1),
  // },
  // '& .MuiDialog-paperWidthSm': {
  //   backgroundColor: '#322d38',
  //   borderRadius: '8px',
  //   display: 'flex',
  //   alignItems: 'center',
  //   width: '600px',
  //   padding: '10px',
  //   overflowX: 'hidden'
  // },
  // '& .MuiDialogContent-dividers': {
  //   borderTop: '0px',
  //   borderBottom: '0px'
  // },
  // '& .MuiTypography-h6': {
  //   textTransform: 'none',
  // },
  // '& .group_7': {
  //   width: '305px',
  //   height: '52px',
  //   margin: '32px 0 0 100px'
  // },
  // '& .flex-row': {
  //   display: 'flex',
  //   flexDirection: 'row'
  // },
  // '& .flex-col': {
  //   display: 'flex',
  //   flexDirection: 'column'
  // },
  // '& .text-wrapper_13': {
  //   width: '137px',
  //   height: '52px',
  //   overflowWrap: 'break-word',
  //   fontSize: '0',
  //   fontFamily: 'MicrosoftYaHei',
  //   fontWeight: 'NaN',
  //   textAlign: 'right',
  //   whiteSpace: 'nowrap',
  //   lineHeight: '34px'
  // },
  // '& .text_14': {
  //   width: '137px',
  //   height: '52px',
  //   overflowWrap: 'break-word',
  //   color: '#48EF37',
  //   fontSize: '36px',
  //   fontFamily: 'MicrosoftYaHei',
  //   fontWeight: 'NaN',
  //   textAlign: 'left',
  //   whiteSpace: 'nowrap',
  //   lineHeight: '34px',
  // },
  // '& .text_15': {
  //   width: '137px',
  //   height: '52px',
  //   overflowWrap: 'break-word',
  //   color: 'red',
  //   fontSize: '60px',
  //   fontFamily: 'MicrosoftYaHei',
  //   fontWeight: 'NaN',
  //   textAlign: 'left',
  //   whiteSpace: 'nowrap',
  //   lineHeight: '34px'
  // },
  // '& .text-wrapper_14': {
  //   width: '305px',
  //   height: '18px',
  //   margin: '35px 0 0 0px'
  // },
  // '& .text_12': {
  //   width: '305px',
  //   height: '18px',
  //   overflowWrap: 'break-word',
  //   color: 'rgba(255, 255, 255, 1)',
  //   fontSize: '16px',
  //   fontFamily: 'MicrosoftYaHei-Bold',
  //   fontWeight: '700',
  //   textAlign: 'center',
  //   whiteSpace: 'nowrap',
  //   lineHeight: '18px'
  // },
  // '& .block_6': {
  //   width: '542px',
  //   height: '204px',
  //   margin: '19px 0 0 0px'
  // },
  // '& .text-wrapper_9': {
  //   backgroundColor: 'rgba(33, 28, 39, 1)',
  //   borderRadius: '7px',
  //   height: '204px',
  //   width: '542px',
  //   overflowY: 'auto'
  // },
  // '& .paragraph_2': {
  //   width: '156px',
  //   //height: '154px',
  //   overflowWrap: 'break-word',
  //   color: 'rgba(205, 204, 208, 1)',
  //   fontSize: '16px',
  //   fontFamily: 'MicrosoftYaHei',
  //   fontWeight: 'NaN',
  //   textAlign: 'left',
  //   lineHeight: '34px',
  //   margin: '0px 0 0 24px',
  // },
  // '& .paragraph_3': {
  //   width: '305px',
  //   //height: '151px',
  //   overflowWrap: 'break-word',
  //   color: 'rgba(217, 215, 215, 1)',
  //   fontSize: '16px',
  //   fontFamily: 'MicrosoftYaHei',
  //   fontWeight: 'NaN',
  //   textAlign: 'right',
  //   lineHeight: '34px',
  //   margin: '0px 42px 0 0px'
  // },
  // '& .text-wrapper_10': {
  //   height: '48px',
  //   backgroundSize: '100% 100%',
  //   width: '250px',
  //   backgroundColor: '#ff0000',
  //   borderRadius: '100px',
  //   cursor: 'pointer',
  //   justifyContent: 'center'
  // },
  // '& .text-wrapper_11': {
  //   height: '48px',
  //   backgroundSize: '100% 100%',
  //   width: '250px',
  //   backgroundColor: '#808280',
  //   borderRadius: '100px',
  //   cursor: 'pointer',
  //   justifyContent: 'center'
  // },
  // '& .text_13': {
  //   width: '100%',
  //   height: '24px',
  //   overflowWrap: 'break-word',
  //   color: 'rgba(255, 255, 255, 1)',
  //   fontSize: '18px',
  //   fontFamily: 'MicrosoftYaHei',
  //   fontWeight: 'NaN',
  //   textAlign: 'center',
  //   whiteSpace: 'nowrap',
  //   lineHeight: '24px',
  //   margin: '0px 0 0 0px'
  // },
  // '& .block_7': {
  //   width: '250px',
  //   height: '48px',
  //   margin: '0px 0 0px 0px'
  // }
}));
// const StripeDialog = styled(Dialog)(({ theme }) => ({
//   '& .MuiTypography-h6': {
//     width: '100%'
//   },
// }));

class GameNew extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.thumbSwiper = null;
    this.masterSwiper = null;
    this.agreeBounty = null;
    this.agreeKey = null;
    this.state = {
      activeTab: 1,
      activeGalleryIndex: 0,
      swiper: null,
      currentActiveTab: 0,
      isModalVisible: false,
      counterValue: 0,
      platform: 'pc',
      purchaseMethod: 'b',
      paymentMethod: 'noiz',
      quantity: 1,
      giftEmail: '',
      products: [],
      product: null,
      minProduct: null,
      dialogPayOpen: false,
      curOrder: null,
      dialogResultOpen: false,
      payErrorType: 0,
      sendEmail: "",
      orderDeliveryStatus: "pending",
      isStripeModalOpen: false,
      isProcessingStripe: false,
      errorText: null
    };
    this.handleStripeSuccess = this.handleStripeSuccess.bind(this);
    this.handleStripeError = this.handleStripeError.bind(this);
    this.handleProceedToStripe = this.handleProceedToStripe.bind(this);
    this.handleCloseStripeModal = this.handleCloseStripeModal.bind(this);
  }

  componentDidMount() {
    // 进入页面时刷新用户信息（获取最新 connectedAccounts 等）
    const token = this.props.auth?.token;
    try {
      this.props.validateUserHandshake(token, '');
    } catch (e) {
      // ignore
    }
  }
  UNSAFE_componentWillMount() {
    const {
      auth: {
        token,
        user: {
          country,
          firstName,
          lastName,
        },
      },
      router: { replace, params: { gameId } },
      getGame,
      getCDKProducts,
      getGameGuest,
    } = this.props;
    if (isAuthenticated()) {
      const isBasicInfoCompleted = (firstName && lastName && country);
      if (!isBasicInfoCompleted) {
        replace('/complete-registration');
      } else {
        if (gameId) {
          getGame(gameId, token);
          getCDKProducts(gameId, 0, null, false, token, 0);
        }
      }
    } else {
      if (gameId) {
        getGameGuest(gameId);
      }
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.config.game.isLoading === true &&
      nextProps.config.game.isLoading === false) {
      // // When login fails or user is trying to hack/test out to date OAuth Code in query string:
      if (nextProps.config.game.errors.hasError) {
        if (nextProps.config.game.errors.code === 'E_GAME_NOT_AVAILABLE') {
          this.props.router.replace('/not-found');
        } else {
          this.props.router.replace('/not-found');
        }
      }
    }
    if (this.props.user.myPreApprovedGameKeys.isRequestingAGameKey === true &&
      nextProps.user.myPreApprovedGameKeys.isRequestingAGameKey === false) {
      // // When login fails or user is trying to hack/test out to date OAuth Code in query string:
      if (nextProps.user.myPreApprovedGameKeys.errors.hasError) {
        simpleNotification({
          level: 'error',
          title: nextProps.user.myPreApprovedGameKeys.errors.code,
          message: nextProps.user.myPreApprovedGameKeys.errors.message,
        });
      } else {
        this.openModal('KeyComing');
      }
    }
    if (this.props.user.myBounties.isJoiningToABounty === true &&
      nextProps.user.myBounties.isJoiningToABounty === false) {
      // // When login fails or user is trying to hack/test out to date OAuth Code in query string:
      if (nextProps.user.myBounties.errors.hasError) {
        simpleNotification({
          level: 'error',
          title: nextProps.user.myBounties.errors.code,
          message: nextProps.user.myBounties.errors.message,
        });
      } else {
        this.changeModalStep(2);
      }
    }
    if (this.props.user.myBounties.isLeavingABounty === true &&
      nextProps.user.myBounties.isLeavingABounty === false) {
      // // When login fails or user is trying to hack/test out to date OAuth Code in query string:
      if (nextProps.user.myBounties.errors.hasError) {
        simpleNotification({
          level: 'error',
          title: nextProps.user.myBounties.errors.code,
          message: nextProps.user.myBounties.errors.message,
        });
      } else {
        this.closeModal();
      }
    }
    if (this.props.user.cdkProducts.isLoading === true &&
      nextProps.user.cdkProducts.isLoading === false) {
      if (nextProps.user.cdkProducts.errors.hasError) {
      } else {
        if (nextProps.user.cdkProducts.data && nextProps.user.cdkProducts.data.length > 0) {
          const minCp = nextProps.user.cdkProducts.data.reduce((min, cp) => { return min.salePrice < cp.salePrice ? min : cp });
          this.setState({ platform: minCp.platform.id, product: minCp, products: nextProps.user.cdkProducts.data.filter(cp => cp.platform.id === minCp.platform.id), minProduct: minCp });
        }
      }
    }
    if (this.props.user.cdkOrder.isLoading === true &&
      nextProps.user.cdkOrder.isLoading === false) {
      if (nextProps.user.cdkOrder.errors.hasError) {
        if (nextProps.user.cdkOrder.errors.code === 'E_ORDER_HAVE_NOT_PAY') {
          simpleNotification({
            level: 'error',
            title: 'Order error',
            message: 'There is an order to be paid, please complete the payment first',
          });
        } else if (nextProps.user.cdkOrder.errors.code === 'E_CDK_BUY_LIMIT') {
          const warnType = nextProps.user.cdkOrder.errors.message?.split(',')[0];
          let warnMessage;
          if (warnType === '1') {
            warnMessage = "Your recent trading frequency has been too high. Please make another purchase 24 hours later.";
          } else if (warnType === '2') {
            warnMessage = "Your recent transaction amount has been too high. Please make another purchase 24 hours later.";
          } else if (warnType === '3') {
            warnMessage = "Your recent trading IP has been abnormal. Please make another purchase 24 hours later.";
          } else if (warnType === '4') {
            warnMessage = "You have been frequently initiating refunds recently. Please make another purchase 24 hours later.";
          } else if (warnType === '-1') {
            warnMessage = "Your account is restricted from purchasing CDK.";
          }
          simpleNotification({
            level: 'error',
            title: 'Order error',
            message: `${warnMessage} If you need service support, please contact us system support@noiz.gg`,
          });
        } else {
          simpleNotification({
            level: 'error',
            title: 'Order error',
            message: nextProps.user.cdkOrder.errors.message,
          });
        }
      } else {
        if (nextProps.user.cdkOrder.data) {
          if (nextProps.user.cdkOrder.code !== 'CANCEL_CDK_ORDER') {
            if (nextProps.user.cdkOrder.data.order) {
              //this.setState({payOrderId: nextProps.user.cdkOrder.data.orderId});
              this.showPayDialog(nextProps.user.cdkOrder.data.order);
            } else {
              simpleNotification({
                level: 'error',
                title: 'Order error',
                message: 'Unable to make payment',
              });
            }
          }
        }
        const token = this.props.auth?.token;
        const { gameId } = this.props.router.params;
        this.props.getCDKProducts(gameId, 0, null, false, token, 0);
      }
    }
    if ((this.props.user.cdkOrder_p.isLoading === true && nextProps.user.cdkOrder_p.isLoading === false)) {
      // // When login fails or user is trying to hack/test out to date OAuth Code in query string:
      if (nextProps.user.cdkOrder_p.errors.hasError) {
        if (nextProps.user.cdkOrder_p.errors.code === 'E_WALLET_AMOUNT') {
          this.setState({ payErrorType: 2, dialogResultOpen: true });
        } else {
          this.setState({ payErrorType: -1, dialogResultOpen: true });
        }
      } else {
        this.setState({ payErrorType: 0, dialogResultOpen: true, sendEmail: nextProps.user.cdkOrder_p.data.sendEmail });
      }
    }
    if ((this.props.user.orderLink.isLoading === true && nextProps.user.orderLink.isLoading === false)) {
      // // When login fails or user is trying to hack/test out to date OAuth Code in query string:
      if (nextProps.user.orderLink.errors.hasError) {
        this.setState({ payErrorType: -1, dialogResultOpen: true });
      } else {
        this.setState({ payErrorType: 1, dialogResultOpen: true });
      }
    }
  }

  getQuest = (quest, userQuest) => {
    if (quest.comingSoon) {
      return null;
    } else if (userQuest && (userQuest.status === 'normal' || userQuest.status === 'approved')) {
      // browserHistory.push(`/my-quests/${quest.id}`);
      this.props.router.push(`/quests/${quest.slug || quest.id}`);
    } else {
      this.props.router.push(`/quests/${quest.slug || quest.id}`);
    }
  }

  generateGameGalleryHTML(gallery) {
    // If no active games show this message
    const images = gallery.filter(item => item.type === 'image');
    const videos = gallery.filter(item => item.type === 'video');

    if (gallery.length <= 0) {
      return (<div className="NoGallery">No Resource at this moment.</div>);
    }

    return (<section className="GameGallery">
      <section className="GameGallery__wrapper">
        {images.length > 0 && <GameGallery gallery={images} isGameNew={true} />}
        {/* {
          images.length > 0 && (
            <section className="GameGallery__Item">
              <section className="GameGallery__title">Games gallery</section>
              <section className="GameGallery__line"></section>
              <section className="GameGallery__image__content">
                {images.map((image, index) => (
                  <section key={index} className="GameGallery__image">
                    <figure style={{ backgroundImage: `url(${image.url})` }} />
                  </section>
                ))}
              </section>
            </section>
          )
        } */}
        {
          videos.length > 0 && (
            <section className="GameGallery__Item__Bottom">
              <section className="GameGallery__title">games promotional video</section>
              <section className="GameGallery__line"></section>
              <section className="GameGallery__video__content">
                {videos.map((video, index) => (
                  <section key={index} className="GameGallery__video"
                  // onMouseEnter={this.pauseAutoPlay}
                  // onMouseLeave={this.resumeAutoPlay}
                  // onTouchStart={this.pauseAutoPlay}
                  >
                    <iframe
                      className="youtube-video"
                      title="youtube-video"
                      width="100%"
                      height="100%"
                      src={`${video.url}?autoplay=1&rel=0`}
                      // frameBorder="0"
                      allowFullScreen
                    />
                  </section>
                ))}

              </section>
            </section>
          )
        }
      </section>
    </section>)
  }

  generateGameQuestsHTML(quests = [], isLoading, myQuests = [], myUserQuests = [], game) {
    if (game && quests && !isLoading && quests.length > 0) {
      // const today = dayjs();
      return quests.map((quest, i) => {
        const userQuest = find(myUserQuests, o => (o.quest === quest.id));
        let declined = false;
        let applied = false;
        if (userQuest && userQuest.status === 'declined') {
          declined = true;
        } else if (userQuest && userQuest.status === 'pending') {
          applied = true;
        }

        // const alreadyIn = find(myQuests, questItem => questItem.id === quest.id);

        // 修改为使用已定义的 userQuest 变量和状态检查
        const alreadyIn = userQuest && (userQuest.status === 'approved' || userQuest.status === 'normal');
        let dateInterval;
        if (quest.startDateTime && quest.endDateTime) {
          dateInterval = `${localizeIncorrectDate(quest.startDateTime).format('MM/DD')} - ${localizeIncorrectDate(quest.endDateTime).format('MM/DD')}`;
        }
        /*  <-------- START - End Date Time (ended) Validation -------->  */
        let questEnded = false;
        if (quest.endDateTime) {
          questEnded = isQuestOver(quest);
        }
        /*  <-------- END - End Date Time (ended) Validation -------->  */
        let buttonText = ""
        // START - Button HTML
        // let buttonHTML = <React.Fragment />;
        if (questEnded) {
          // buttonHTML = (<button className="SeeQuest disabled">Quest Ended</button>);
          buttonText = "Quest Ended"
        } else if (applied) {
          // buttonHTML = (<button className="SeeQuest disabled">Applied</button>);
          buttonText = "Applied"
        } else if (declined) {
          // buttonHTML =
          //   (
          //     <button className="SeeQuest disabled">
          //       <div className="tooltip">Declined <i className="fa fa-info-circle" aria-hidden />
          //         <span className="tooltiptext">
          //           You were not selected for this quest. Check the quests page and your email for other opportunities.
          //         </span>
          //       </div>
          //     </button>
          //   );
          buttonText = "Declined"
        } else if (alreadyIn) {
          // buttonHTML = <button className="SeeQuest">Joined</button>;
          buttonText = "Joined"
        } else {
          // buttonHTML =
          //   (
          //     <button
          //       className={classNames('SeeQuest', { disabled: (typeof quest.openSpots === 'undefined' || quest.openSpots <= 0) })}
          //     >
          //       See Quest
          //     </button>
          //   );
          buttonText = "See Quest"
        }
        // END - Button HTML
        // START - Tiered quest title
        let questTitle = quest.title;
        if (quest.type === 'tiered' || quest.type === 'tiered-one-time' || quest.type === 'tiered-multi-days') {
          const unpaidQuest2 = (quest.paymentAmount < 0);
          const hours = Math.floor(quest.requiredStreamTimeMinutes / 60);
          const minutes = quest.requiredStreamTimeMinutes % 60;
          const textMinutes = (minutes !== 0) ? ` ${minutes} minutes` : '';
          let textHours = '';
          if (hours === 1) {
            textHours = '1 hour';
          } else if (hours > 1) {
            textHours = `${hours} hours`;
          }
          if (quest.paymentAmount === 0 && !unpaidQuest2) {
            questTitle = quest.title;
            if (quest.openSpots > 0 || alreadyIn) {
              questTitle = `${quest.title}`;
            }
          } else if (quest.frequency === 'one-time' && !unpaidQuest2) {
            questTitle = `${quest.title} - Play for ${textHours}${textMinutes} and earn! - ${getCurCurrencyOfUnit(game.region?.currency, quest.paymentAmount)}`;
          } else if (quest.frequency === 'daily' && !unpaidQuest2) {
            questTitle = `${quest.title} - Play for ${textHours}${textMinutes} and earn! - ${getCurCurrencyOfUnit(game.region?.currency, quest.paymentAmount)}`;
          } else {
            questTitle = quest.title;
          }
        }
        // END - Tiered quest title
        // const paymentAmountNew = getPaymentAmountForAuto(quest.splitTiers || [], quest.rankTiers || []);

        const { paymentAmount = 0 } = getPaymentAmountNew(
          quest.splitTiers || [],
          quest.rankTiers || [],
          quest.memberTiers || [],
          this.props.auth.user,  // 添加用户信息 (safe for guest)
          quest.viewerTiers || [],
          userQuest,  // 可选，如果有的话
          quest,
        );

        return (
          <section
            key={quest.id}
            className={classNames('QuestCard', { 'coming-soon': quest.comingSoon })}
            onClick={this.getQuest.bind(this, quest, userQuest)}
            aria-hidden
          >
            <section className="QuestCard__wrapper">
              <div className="QuestCard__image">
                <figure style={{ backgroundImage: `url(${game ? game.cover : ''})` }} alt="Game Cover" />
              </div>

              <section className={classNames('QuestCard__level', {
                'type-1': quest.type === 'tiered-one-time' || quest.type === 'tiered-auto',
                'type-2': quest.type === 'basic' || quest.type === 'youtube-video',
              })}>
                {/* <div className="QuestCard__level--wrapper">
                  <div className="QuestCard__level--count">{quest.noizPoints || 0}</div>
                </div> */}
                {this.getQuestTypeDisplayName(quest.type)}
              </section>
              <section className="QuestCard__details">
                <div className="QuestCard__background-top" />
                <div className="QuestCard__background-bottom" />
                <section className="QuestCard__details-wrapper">
                  <section className="QuestCard__details--row">
                    {/* <i
                      className={classNames('QuestCard__details--icon', {
                        'noiz-video-camera': quest.type === 'paid bounty',
                        'noiz-game-controller': (quest.type === 'early access key' || quest.type === 'influencers early access'),
                        'noiz-thumbs-up': quest.type === 'alpha feedback',
                        'noiz-discount': quest.type === 'referral',
                        'fa fa-gear': quest.type === 'default',
                        'fa fa-clock-o': quest.type === 'timed',
                        'fa fa-external-link': quest.type === 'link out',
                      })}
                    /> */}
                    <section className="QuestCard__details--info">
                      <section className="primary-info">
                        <div className="QuestCard__details--name">
                          {this.truncateText(questTitle, 60)}
                        </div>
                      </section>
                      {/* <section className="sub-info">
                        <div className="QuestCard__details--game-name">
                          {game.name}
                        </div>
                        <div className="QuestCard__details--date-interval">
                          {dateInterval || 'No Date'}
                        </div>
                      </section> */}
                    </section>
                  </section>

                  <div className="red-line"></div>
                  <div className='QuestCard__details_details_price_date'>
                    <div className='price'>
                      {paymentAmount === Number.MIN_SAFE_INTEGER ? '--' :
                        paymentAmount === -1 ? 'Free Key' :
                          paymentAmount === -2 ? 'Points' :
                            paymentAmount > 0 ? (
                              <>
                                {(quest.type === 'tiered-auto' || quest.type === 'secondary-creation') ? 'UP TO ' : ''}
                                ${paymentAmount}
                              </>
                            ) : '--'}
                    </div>
                    <div className='time'> {dateInterval || 'No Date'}</div>
                  </div>

                  <section className={classNames('QuestCard__details--bottom', {
                    'apply': buttonText === 'See Quest',
                    'joined': buttonText === 'Joined',
                    'others': buttonText !== 'See Quest' && buttonText !== 'Joined',
                  })}>
                    {/* Button HTML */}
                    {buttonText}
                  </section>
                  {/* <section className="QuestCard__details--row">
                    {(typeof quest.openSpots !== 'undefined' && quest.openSpots > 0) && (
                      <div className="QuestCard__details--open-slots" style={{ color: (questEnded || quest.hideOpenSpots) ? '#212227' : '#83858c' }}>
                        {(quest.openSpots - quest.usersIn) || 0} open spots
                      </div>
                    )}

                    {(typeof quest.openSpots === 'undefined' || quest.openSpots <= 0) && (
                      <div className="QuestCard__details--open-slots" style={{ color: (questEnded || quest.hideOpenSpots) ? '#212227' : '#83858c' }}>
                        <span>0 open spots</span>
                      </div>
                    )}
                  </section> */}
                </section>
              </section>
              {/* {(quest.comingSoon) && (
                <section className="QuestCard__info-panel">
                  <h4 className="QuestCard__info-panel--title">Coming Soon</h4>
                  <section className="QuestCard__info-panel--details">
                    <Truncate lines={10} ellipsis={<span>...</span>}>
                      {ReactHtmlParser(quest.description)}
                    </Truncate>
                  </section>
                </section>
              )} */}
            </section>
          </section>
        );
      });
    }
    // If no active games show this message
    return (<div className="NoQuests">No Quests at this moment.</div>);
  }

  handleTabChange = (param) => {
    if (param !== 2) this.pauseAutoPlay();
    else this.resumeAutoPlay();

    this.setState({
      activeTab: param,
    });
  }

  handleCurrentTabChange = (param) => {
    this.setState({
      currentActiveTab: param
    })
  }

  getQuestTypeDisplayName = (questType) => {
    const questTypeMapping = {
      'tiered-one-time': 'Live Streaming',
      // Add other mappings if needed
      'tiered-auto': 'Prize Pool',
    };

    return questTypeMapping[questType] || questType;
  };
  goToSlide = (index) => {
    this.setState({
      activeGalleryIndex: index,
    });
  }

  truncateText = (text, maxLength) => {
    if (!text) {
      return ""
    }

    if (text.length > maxLength) {
      return text.substring(0, maxLength) + '...';
    }
    return text;
  };

  pauseAutoPlay = () => {
    if (this.state.swiper && this.state.swiper.autoplay) this.state.swiper.autoplay.stop();
  }

  resumeAutoPlay = () => {
    if (this.state.swiper && this.state.swiper.autoplay) this.state.swiper.autoplay.start();
  }

  toggleModal = () => {
    this.setState((prevState) => ({ isModalVisible: !prevState.isModalVisible }));
  };

  handleBuyButtonClick = () => {
    // Implement the logic to handle the buy button click
    this.toggleModal(); // Example: Toggle the modal on button click
  };

  handleCounterChange = (count) => {
    this.setState({ counterValue: count });
  };

  handlePlatformChange = (platform) => {
    const { data: cdkProducts = [] } = this.props.user?.cdkProducts;
    const cps = cdkProducts.filter(cp => cp.platform.id === platform);
    this.setState({ platform: platform, products: cps });
    if (cps && cps.length > 0) {
      this.setState({ product: cps[0] });
      this.handleProductChange(cps[0]);
    } else {
      this.setState({ product: null, quantity: 0 });
    }
  }

  handlePayment = () => {
    const token = this.props.auth?.token;
    const { product, quantity, paymentMethod, purchaseMethod, giftEmail } = this.state;
    if (!product || !purchaseMethod) {
      simpleNotification({ level: 'error', title: 'Missing Information', message: 'Please select product and purchase method.' });
      return;
    }

    if (purchaseMethod === 'g' && (!giftEmail || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(giftEmail))) {
      simpleNotification({
        level: 'error',
        title: "Email is invalid",
        message: 'The email format is incorrect',
      });
      return;
    }
    if (quantity <= 0) {
      simpleNotification({
        level: 'error',
        title: "Quantity error",
        message: 'The quantity must be greater than zero',
      });
      return;
    }

    if (product && quantity && paymentMethod && purchaseMethod) {
      if (!token) {
        simpleNotification({ level: 'error', title: 'Login required', message: 'Please login to complete the purchase.' });
        return;
      }
      this.toggleModal();
      this.props.buyCDK(product.id, product.salePrice, quantity, paymentMethod, purchaseMethod, giftEmail, token);
    } else {
      simpleNotification({ level: 'error', title: 'Missing Information', message: 'Please complete all selections.' });
      return;
    }

  }

  handleProceedToStripe = () => {
    const { product, quantity, purchaseMethod, giftEmail } = this.state;
    if (purchaseMethod === 'g' && (!giftEmail || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(giftEmail))) {
      simpleNotification({ level: 'error', title: "Email is invalid", message: 'The email format is incorrect' });
      return;
    }
    if (!product || quantity <= 0 || !purchaseMethod) {
      simpleNotification({ level: 'error', title: 'Missing Information', message: 'Please select product, quantity, and purchase method.' });
      return;
    }
    this.setState({ isStripeModalOpen: true, isModalVisible: false, isProcessingStripe: false });
  }

  handleCloseStripeModal1 = () => {
    // 如果正在处理中，不允许关闭
    if (this.state.isProcessingStripe) return;
    this.setState({ isStripeModalOpen: false });
  }

  handleCloseStripeModal = () => {
    this.setState({ isStripeModalOpen: false, dialogPayOpen: false });
  }

  handleStripeSuccess = (orderData) => {
    console.log("Stripe Payment and Order Confirmation Success in GameNew:", orderData);

    // 准备显示成功信息
    this.setState({
      isStripeModalOpen: false, // 关闭Stripe弹窗
      dialogResultOpen: true,   // 打开结果弹窗
      payErrorType: 0,          // 设置为成功类型
      sendEmail: this.state.purchaseMethod === 'g' ? this.state.giftEmail : (this.props.auth?.user?.email || ''),
      orderDeliveryStatus: orderData.deliveryStatus || 'pending',
      isProcessingStripe: false
    });

    // **在这里触发用户数据刷新**
    const token = this.props.auth?.token; // 从 props 获取 token (safe)
    if (token) {
      console.log('[GameNew] Payment successful, dispatching validateUserHandshake to refresh user data.');
      // 优先使用通过 mapDispatchToProps 绑定的 action creator
      if (typeof this.props.validateUserHandshake === 'function') {
        this.props.validateUserHandshake(token, '');
      } else if (this.props.dispatch) { // 否则，回退到直接使用 dispatch
        this.props.dispatch(validateUserHandshake(token, ''));
      } else {
        console.error('[GameNew] Cannot dispatch validateUserHandshake: neither mapped prop nor dispatch is available.');
      }
      // 如果你将来实现了 fetchCurrentUser action，可以这样调用：
      // if (typeof this.props.fetchCurrentUser === 'function') {
      //   this.props.fetchCurrentUser(token);
      // } else if (this.props.dispatch) {
      //   this.props.dispatch(fetchCurrentUser(token));
      // }
    } else {
      console.warn('[GameNew] No auth token found, cannot refresh user data after payment.');
    }
  }

  handleStripeError = (error) => {
    console.error("Stripe Payment or Order Confirmation Error:", error);

    // 使用已导入的getDetailedErrorMessage函数
    const errorText = error.message || (error.error && error.error.message) || '支付处理过程中出现错误，请重试';

    // 设置为更友好的错误信息，而不仅仅是默认消息
    this.setState({
      isProcessingStripe: false,
      dialogResultOpen: true,
      payErrorType: 1, // 支付失败
      errorText: errorText // 存储格式化的错误消息供显示使用
    });
  }

  showPayDialog = (order) => {
    this.setState({ dialogPayOpen: true, curOrder: order });
  }

  handlePayClose = () => {
    const token = this.props.auth?.token;
    const { curOrder } = this.state;
    if (curOrder && token) {
      this.props.cancelCDKOrder(curOrder.id, token);
    }
    this.setState({ dialogPayOpen: false });
  }

  payOrder = () => {
    const token = this.props.auth?.token;
    const { curOrder, paymentMethod } = this.state;
    if (curOrder && paymentMethod) {
      if (!token && paymentMethod !== 'stripe') {
        simpleNotification({ level: 'error', title: 'Login required', message: 'Please login to complete this payment.' });
        return;
      }
      if (paymentMethod === 'noiz') {
        this.props.payCDKOrder(curOrder.id, paymentMethod, token);
      } else if (paymentMethod === 'paypal') {
        // this.props.showCDKPay(curOrder.id, token);
      } else if (paymentMethod === 'stripe') {
        this.setState({ isStripeModalOpen: true });
      }

      this.setState({ dialogPayOpen: false });
    }
  }

  handleResultClose = () => {
    this.setState({ dialogResultOpen: false });
  };

  payPaypalOrder = () => {
    const { approvalLink, isLoading } = this.props.user.orderLink.data;
    if (!isLoading) {
      if (approvalLink) {
        window.open(approvalLink, "_blank");
      }
    }
    this.handleResultClose();
  }

  toRecharge = () => {
    const host = window.location.hostname;
    const isLocal = host === 'localhost';
    const finalHost = isLocal ? `${host}:3000` : host;
    const protocol = isLocal ? 'https://' : 'https://';
    window.open(`${protocol}${finalHost}/my-account-detail/wallet`, '_self');
  }

  handleProductChange = (product) => {
    const { quantity } = this.state;
    if (product && quantity) {
      let maxQuantity = 5;
      if (product.onceMax) {
        maxQuantity = product.onceMax;
      }
      if (quantity > maxQuantity) {
        this.setState({ quantity: maxQuantity });
      }
    } else {
      this.setState({ quantity: 0 });
    }
    this.setState({ product: product })
  }

  generateThumbnails() {
    return this.props.config.game.data.gallery.map((item, i) => {
      switch (item.type) {
        case 'video':
          return (
            <button
              key={`thumb-slide-${i}`}
              onMouseEnter={this.pauseAutoPlay}
              onMouseLeave={this.resumeAutoPlay}
              className={classNames('thumb-slide', { active: (this.state.activeGalleryIndex === i) })}
            >
              <div className="thumb-overlay swiper-lazy" style={{ backgroundImage: `url('${item.thumb}')` }} >
                <div className="play-icon">
                  <i className="play-icon fa fa-play" />
                </div>
              </div>
            </button>);
        case 'image':
          return (
            <button
              key={`thumb-slide-${i}`}
              onMouseEnter={this.pauseAutoPlay}
              onMouseLeave={this.resumeAutoPlay}
              className={classNames('thumb-slide', { active: (this.state.activeGalleryIndex === i) })}
            >
              <div className="thumb-overlay swiper-lazy" style={{ backgroundImage: `url('${item.thumb}')` }} />
            </button>);
        default:
          return (
            <button
              key={`thumb-slide-${i}`}
              onMouseEnter={this.pauseAutoPlay}
              onMouseLeave={this.resumeAutoPlay}
              className={classNames('thumb-slide', { active: (this.state.activeGalleryIndex === i) })}
            >
              <div className="thumb-overlay swiper-lazy" style={{ backgroundImage: `url('${item.thumb}')` }} />
            </button>);
      }
    });
  }

  render() {
    // const gameGalleryParams = {
    //   direction: window.innerWidth <= 768 ? 'horizontal' : 'vertical',
    //   spaceBetween: 25,
    //   slidesPerView: 'auto',
    //   centeredSlides: true,
    //   autoplay: {
    //     delay: 3000,
    //   },
    //   on: {
    //     slideChange: () => {
    //       this.setState({ activeGalleryIndex: this.state.swiper.activeIndex });
    //     },
    //   },
    //   speed: 1000,
    //   scrollBar: false,
    //   containerClass: 'GameGalleryThumb',
    //   scrollbar: {
    //     el: '.swiper-scrollbar',
    //     hide: false,
    //   },
    //   freeMode: false,
    //   freeModeMomentum: false,
    //   slideToClickedSlide: true,
    //   mousewheel: true,
    // };

    const { data: game, isLoading: isLoadingGame, quests = [] } = this.props.config.game;
    const { data: myQuests = [] } = this.props.user.myQuests || {};
    const { data: myUserQuests = [] } = this.props.user.myUserQuests || {};
    const { data: cdkProducts = [] } = this.props.user?.cdkProducts;
    // Ensure user is safe for guest views
    const { user } = this.props.auth || {};
    // const swiper = !isEmpty(game) && !isLoadingGame && game.gallery && game.gallery.length > 0 && (
    //   <Swiper
    //     ref={(node) => { if (node && !this.state.swiper) this.setState({ swiper: node.swiper }); }}
    //     {...gameGalleryParams}
    //   >
    //     {this.generateThumbnails()}
    //   </Swiper>
    // );

    const gameGallery = game.gallery || [];
    const {
      isModalVisible,
      platform,
      purchaseMethod,
      paymentMethod,
      quantity,
      products,
      product,
      minProduct,
      dialogPayOpen,
      curOrder,
      payErrorType,
      dialogResultOpen,
      sendEmail,
      giftEmail,
      isStripeModalOpen,
      // orderDeliveryStatus
    } = this.state;
    const images_platforms = game.platforms && getPlatformImages(game.platforms);
    if (cdkProducts && cdkProducts.length > 0) {
      const cps = cdkProducts.reduce((acc, p) => {
        if (!acc[p.platform.id]) {
          acc[p.platform.id] = p.platform;
        }
        return acc;
      }, {});
      platformOptions = Object.values(cps);
    }

    const isStripeSelected = paymentMethod === 'stripe';
    const canProceedToPayment = product && quantity > 0 && purchaseMethod && paymentMethod && (!isStripeSelected || (purchaseMethod === 'g' ? giftEmail : true));
    const finalAmount = product ? product.salePrice * quantity : 0;
    //const finalAmountCents = Math.round(finalAmount * 100);

    return (
      <section className="Game">
        <Loading isLoading={isLoadingGame} />
        <section className="Game__container">
          {/* {this.props.auth.token && <Back />} */}
          <section className="GameInfo">
            <figure className="GameInfo__image" style={{ backgroundImage: `url(${game.coverPortrait || game.cover})` }} >
            </figure>
            <section className="GameInfo__details">
              <section className="GameInfo__details--top">
                <div className="GameInfo__details--title">About the game</div>
                <section className="GameInfo__details--content parsed-content">
                  {ReactHtmlParser(this.truncateText(removeHtmlTags(game.description), 400))}
                </section>
              </section>

              <section className="GameInfo__details--bottom">
                <section className="GameInfo__details--item">
                  <div className="title">Game Name</div>
                  <section>{game.name}</section>
                </section>
                <section className="GameInfo__details--item">
                  <div className="title">Game platform</div>
                  {images_platforms && images_platforms.length > 0 ? (
                    <div className="platform-image-list">
                      {images_platforms.map((image, index) => (
                        <img key={index} src={image} alt='platforms' className="platform-image" />
                      ))}
                    </div>
                  ) : (
                    <section>None</section>
                  )}

                </section>
                <section className="GameInfo__details--item">
                  <div className="title">Release Date</div>
                  <section>{game.releaseDate !== '-' ? getLocalTimeString(game.releaseDate, 'YYYY-MM-DD', false) : "TBD"}</section>
                </section>
                <section className="GameInfo__details--item">
                  <div className="title">Developer</div>
                  <section>{game.developer}</section>
                </section>
                <section className="GameInfo__details--item">
                  <div className="title">Publisher</div>
                  <section>{game.publisher}</section>
                </section>
              </section>
            </section>
            {minProduct && <section className='GameInfo__cdkey'>
              <div className="GameInfo__cdkey--wrapper">
                <div className='GameInfo__cdkey--tag1'>GET</div>
                <div className='GameInfo__cdkey--tag2'>CD-KEY</div>
                <div className='GameInfo__cdkey--remaining'>Stock Left:{minProduct && minProduct.availableNum > 999 ? '999+' : minProduct?.availableNum}</div>
                {product.discount > 0 && <div className="price_block">
                  <span className="text_45">{getCurCurrencyOfUnit(minProduct?.currency, minProduct?.price)}</span>
                  <div className="text-wrapper_18 flex-col">
                    <span className="text_46">-{Math.floor(product.discount.toFixed())}%</span>
                  </div>
                </div>}
                <div className='GameInfo__cdkey--price'>{getCurCurrencyOfUnit(minProduct?.currency, minProduct?.salePrice)}</div>
                <div className='GameInfo__cdkey--buy--container' onClick={this.handleBuyButtonClick}>
                  <img src={shop} alt='shop' className='GameInfo__cdkey--buy--icon' />
                  <button className='GameInfo__cdkey--buy--button'>Buy</button>
                </div>
              </div>
            </section>}
          </section>
          <div className='tab-bar-new1'>
            <div className='tab-wrapper'>
              <span
                className={`tab-span ${this.state.currentActiveTab === 0 ? "active" : ""}`}
                // className="tab-span"
                onClick={this.handleCurrentTabChange.bind(this, 0)}
              >
                Quests
              </span>
              <span
                className={`tab-span ${this.state.currentActiveTab === 1 ? "active" : ""}`}
                // className="tab-span"
                onClick={this.handleCurrentTabChange.bind(this, 1)}
              >
                Material
              </span>
            </div>
          </div>

          <div className='tab-line'></div>

          <section className="Games__primary">
            <div className="Games__primary--wrapper">
              <div className={classNames('PrimaryQuestsList', { active: this.state.currentActiveTab === 0 })}>
                {(game && quests && !isLoadingGame && Array.isArray(myQuests) && Array.isArray(myUserQuests)) &&
                  this.generateGameQuestsHTML(quests, isLoadingGame, myQuests, myUserQuests, game)}
              </div>
              <div className={classNames('PrimaryGameMedia', { active: this.state.currentActiveTab === 1 })}>

                {this.generateGameGalleryHTML(gameGallery)}
              </div>
            </div>
          </section>
        </section>

        <CdkeyBuyModal isVisible={isModalVisible} onClose={this.toggleModal}>
          <div className="cdkey-modal-content">
            <div
              className="cdkey-modal-header"
            >
              <img src={game.cover || game.coverPortrait} alt={game.name} className="game-pic" />
              <div className="game-info1">
                <div className="triangle-right"></div>
                <div className="price-tag">{product ? getCurCurrencyOfUnit(product?.currency, product?.salePrice) : '0.00'}</div>

                {product && product.discount > 0 && <div className="section-discount">
                  <span className="text-sale">-{Math.floor(product.discount.toFixed())}%</span>
                  <div className="section-block">
                    <span className="text-price">{getCurCurrencyOfUnit(product?.currency, product.price)}</span>
                  </div>
                </div>}

                <div className="stock-tag">STOCK LEFT: </div>
                <div className="stock-num-tag">{product && product.availableNum > 999 ? '999+' : product?.availableNum}</div>
              </div>
            </div>
            <div className="form-section">
              <div className="form-group">
                <label>Platform of purchase</label>
                <div className="platform-options">
                  {platformOptions.map(platformCur => (
                    <button
                      key={platformCur.id}
                      className={`platform-btn ${platform === platformCur.id ? 'active' : ''}`}
                      onClick={() => this.handlePlatformChange(platformCur.id)}
                      disabled={isStripeSelected && this.state.isStripeModalOpen}
                    >
                      {platformCur.platform}
                    </button>
                  ))}
                </div>
              </div>
              {products && products.length > 0 && <div className="form-group">
                <label>Product of purchase</label>
                <div className="platform-options">
                  {products.map(productCur => (
                    <button
                      key={productCur.id}
                      className={`platform-btn ${product?.id === productCur.id ? 'active' : ''}`}
                      onClick={() => this.handleProductChange(productCur)}
                      disabled={isStripeSelected && this.state.isStripeModalOpen}
                    >
                      {productCur.name}
                    </button>
                  ))}
                </div>
              </div>}
              <div className="form-group">
                <label>Method of purchase</label>
                <div className="purchase-method-options">
                  {purchaseMethodOptions.map(method => (
                    <button
                      key={method.value}
                      className={`method-btn ${purchaseMethod === method.value ? 'active' : ''}`}
                      onClick={() => this.setState({ purchaseMethod: method.value })}
                      disabled={isStripeSelected && this.state.isStripeModalOpen}
                    >
                      {method.label}
                    </button>
                  ))}
                </div>
                {purchaseMethod && <div className="email-note">
                  <div>We will send it to {purchaseMethod === 'g' ? 'the following email address:' : 'your NOIZ registered email address:'}</div>
                  {purchaseMethod === 'g' ? (
                    <input
                      type="email"
                      value={this.state.giftEmail}
                      onChange={e => this.setState({ giftEmail: e.target.value })}
                      placeholder="Enter recipient's email address"
                      className="email-input"
                      disabled={isStripeSelected && this.state.isStripeModalOpen}
                    />
                  ) : (
                    <p className="email-link">{user?.email || 'Guest (login to use registered email)'}</p>
                  )}
                </div>}
              </div>
              <div className="form-group">
                <label>Method of payment</label>
                <div className="payment-method-options">
                  {paymentMethodOptions.map(method => (
                    <button
                      key={method.value}
                      className={`payment-btn ${paymentMethod === method.value ? 'active' : ''}`}
                      onClick={() => this.setState({ paymentMethod: method.value })}
                      disabled={isStripeSelected && this.state.isStripeModalOpen && method.value !== 'stripe'}
                    >
                      {method.value === 'stripe' ? (
                        // CardIconOverlay('')
                        <div className="card-icons">
                          <img src={getCardBrandIcon('visa')} alt="Visa" />
                          <img src={getCardBrandIcon('mastercard')} alt="Mastercard" />
                          <img src={getCardBrandIcon('unionpay')} alt="unionpay" />
                        </div>
                      ) : (
                        <span className={method.icon}></span>
                      )}
                      {method.name}
                    </button>
                  ))}
                </div>
              </div>
            </div>
            <div className="quantity-group">
              <div className="quantity-section">
                <label>Quantity</label>
                <Counter
                  initialCount={quantity}
                  onCountChange={(value) => { this.setState({ quantity: value }) }}
                  min={1}
                  max={product ? (product.availableNum > (product.onceMax ? product.onceMax : 5) ? (product.onceMax ? product.onceMax : 5) : product.availableNum) : 1}
                  value={quantity}
                  className="cdkey-counter"
                  disabled={isStripeSelected && this.state.isStripeModalOpen}
                />
              </div>
            </div>

            <div className="pay-button-container">
              <button
                className={`pay-button ${canProceedToPayment ? 'active' : ''}`}
                onClick={this.handlePayment}
                disabled={!canProceedToPayment || this.state.isStripeModalOpen}
              >
                PAY {getCurCurrencyOfUnit(product?.currency, finalAmount)}
              </button>
            </div>

          </div>
        </CdkeyBuyModal>
        {/* <Dialog
            open={isStripeModalOpen}
            onClose={this.handleCloseStripeModal}
            aria-labelledby="stripe-payment-dialog-title"
            maxWidth="md"
            fullWidth
            PaperProps={{
                style: {
                    backgroundColor: '#322d38',
                    color: '#fff',
                    borderRadius: '12px',
                    overflow: 'hidden'
                },
            }}
        >
            <DialogTitle
                id="stripe-payment-dialog-title"
                style={{
                    borderBottom: '1px solid #3a3643',
                    padding: '20px 24px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}
            >
                <Typography variant="h6" style={{ fontWeight: 'bold' }}>Secure Checkout</Typography>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ fontSize: '14px', marginRight: '10px', color: '#cdccd0' }}>Secured by</span>
                    <img
                        src="https://upload.wikimedia.org/wikipedia/commons/b/ba/Stripe_Logo%2C_revised_2016.svg"
                        alt="Stripe"
                        style={{ height: '20px' }}
                    />
                </div>
            </DialogTitle>
            <DialogContent style={{ padding: '0' }}>
                <div style={{ display: 'flex', flexDirection: 'column', minHeight: '400px' }}>
                    {isStripeModalOpen && product && quantity > 0 && (
                        <Elements stripe={stripePromise}>
                            <StripeCDKCheckoutForm
                                amount={finalAmountCents}
                                currency="USD"
                                productId={product.id}
                                quantity={quantity}
                                purchaseMethod={purchaseMethod}
                                giftEmail={giftEmail}
                                onSuccess={this.handleStripeSuccess}
                                onError={this.handleStripeError}
                                authToken={authToken}
                                onClose={this.handleCloseStripeModal}
                            />
                        </Elements>
                    )}
                </div>
            </DialogContent>
        </Dialog> */}
        {isStripeModalOpen && <StripeDialog open={isStripeModalOpen} onClose={this.handleCloseStripeModal} order={curOrder} {...this.props}></StripeDialog>}
        {/*<StripeDialog
          open={isStripeModalOpen}
          onClose={this.handleCloseStripeModal}
          aria-labelledby="stripe-payment-dialog-title"
          maxWidth="md"
          fullWidth
          disableBackdropClick={this.state.isProcessingStripe}
          disableEscapeKeyDown={this.state.isProcessingStripe}
          PaperProps={{
            style: {
              backgroundColor: '#322d38',
              color: '#fff',
              borderRadius: '12px',
              overflow: 'hidden'
            },
          }}
        >
          <DialogTitle
            id="stripe-payment-dialog-title"
            sx={{ width: '100%' }}
            style={{
              borderBottom: '1px solid #3a3643',
              padding: '20px 24px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}
          >
            <Box display="flex" justifyContent="space-between" width="100%">
              <div>
                <Typography variant="h6" style={{ fontWeight: 'bold' }}>secure payment</Typography>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span style={{ fontSize: '14px', marginRight: '10px', color: '#cdccd0' }}>By</span>
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/b/ba/Stripe_Logo,_revised_2016.svg"
                    alt="Stripe"
                    style={{ height: '20px' }}
                  />
                  <span style={{ fontSize: '14px', marginLeft: '10px', color: '#cdccd0' }}>Provide secure payment</span>
                </div>
              </div>
              <IconButton
                aria-label="close"
                onClick={this.handleCloseStripeModal}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
                style={{ float: 'right' }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
          </DialogTitle>
          <DialogContent style={{ padding: '0' }}>
            <div style={{ display: 'flex', flexDirection: 'column', minHeight: '400px' }}>
              {isStripeModalOpen && product && quantity > 0 && (
                <Elements stripe={stripePromise}>
                  <StripeCDKCheckoutForm
                    amount={curOrder.balance}
                    currency={curOrder?.currency}
                    productId={curOrder.product}
                    quantity={curOrder.amount}
                    purchaseMethod={'stripe'}
                    giftEmail={giftEmail}
                    onSuccess={this.handleStripeSuccess}
                    onError={this.handleStripeError}
                    authToken={authToken}
                    onClose={this.handleCloseStripeModal}
                    order={curOrder}
                    user={user}
                    setProcessingState={(isProcessing) => this.setState({ isProcessingStripe: isProcessing })}
                    onRequiresAction={() => { // 新增的回调处理
                      console.log("Payment requires additional verification step.");
                      // 可选：在这里更新 GameNew 组件的状态以显示提示信息
                      this.setState({ showScaNotification: true });
                    }}
                  />
                </Elements>
              )}
            </div>
          </DialogContent>
        </StripeDialog>*/}
        <BootstrapDialog
          aria-labelledby="customized-dialog-title"
          open={!!false}
        >
          <DialogContent dividers>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Typography variant='body1' component="div" gutterBottom style={{ minWidth: '150px', }}>Product&nbsp;Type</Typography>
              <Typography variant='body1' component="div" gutterBottom style={{ minWidth: '200px', textAlign: 'right' }}>{curOrder?.productName}-{curOrder?.platformName}</Typography>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Typography variant='body1' component="div" gutterBottom style={{ minWidth: '150px', }}>Price</Typography>
              <Typography variant='body1' component="div" gutterBottom style={{ minWidth: '200px', textAlign: 'right' }}>{getCurCurrencyOfUnit(curOrder?.currency, curOrder?.salePrice ? roundingMoney(curOrder?.salePrice, 2) : '0.00')}</Typography>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Typography variant='body1' component="div" gutterBottom style={{ minWidth: '150px', }}>Amount</Typography>
              <Typography variant='body1' component="div" gutterBottom style={{ minWidth: '200px', textAlign: 'right' }}>{curOrder?.amount}</Typography>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Typography variant='body1' component="div" gutterBottom style={{ minWidth: '150px', }}>Total</Typography>
              <Typography variant='body1' component="div" gutterBottom style={{ minWidth: '200px', textAlign: 'right' }}>{getCurCurrencyOfUnit(curOrder?.currency, curOrder?.balance ? roundingMoney(curOrder?.balance, 2) : '0.00')}</Typography>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Typography variant='body1' component="div" gutterBottom style={{ minWidth: '150px', }}>Method Of Payment</Typography>
              <Typography variant='body1' component="div" gutterBottom style={{ minWidth: '200px', textAlign: 'right' }}>{this.state.paymentMethod}</Typography>
            </div>

          </DialogContent>
          <DialogActions>
            <Button autoFocus style={{ fontSize: '16px', fontWeight: '800', backgroundColor: '#CAC1C4', color: '#fff', borderRadius: '8px', padding: '10px 50px', boxShadow: '0px 4px 8px rgba(0,0,0,0.5)', textTransform: 'none' }} onClick={this.handlePayClose.bind(this)}>
              Cancel
            </Button>
            <Button style={{ marginLeft: '20px', fontSize: '16px', fontWeight: '800', backgroundColor: '#76b452', color: '#fff', borderRadius: '8px', padding: '10px 50px', boxShadow: '0px 4px 8px rgba(0,0,0,0.5)', textTransform: 'none' }} onClick={this.payOrder.bind(this)}>
              Make Payment
            </Button>
          </DialogActions>
        </BootstrapDialog>
        <BootstrapDialog
          aria-labelledby="customized-dialog-title"
          open={!!false}
        >
          <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title" style={{ color: (payErrorType !== 0) ? '#ff0000' : '' }}>
            {payErrorType === -1 && 'Failure to payment'}
            {payErrorType === 1 && 'Do you want to redirect to the payment page to complete the payment?'}
            {payErrorType === 2 && 'NOIZ wallet has insufficient balance'}
            {payErrorType === 0 && 'Payment successful.'}
          </DialogTitle>
          <DialogContent dividers>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              {payErrorType === 0 && <Typography variant='body1' component="div" gutterBottom style={{ minWidth: '150px', }}>
                Your CDKEY has been sent to {sendEmail}
              </Typography>}
            </div>
          </DialogContent>
          <DialogActions>
            <Button style={{ marginLeft: '20px', fontSize: '16px', fontWeight: '800', backgroundColor: '#CAC1C4', color: '#fff', borderRadius: '8px', padding: '10px 50px', boxShadow: '0px 4px 8px rgba(0,0,0,0.5)', textTransform: 'none' }} onClick={this.handleResultClose.bind(this)}>
              Close
            </Button>
            {(payErrorType === 1 && !this.state.errorText) && (
              <Button style={{ marginLeft: '20px', fontSize: '16px', fontWeight: '800', backgroundColor: '#76b452', color: '#fff', borderRadius: '8px', padding: '10px 50px', boxShadow: '0px 4px 8px rgba(0,0,0,0.5)', textTransform: 'none' }} onClick={this.payPaypalOrder.bind(this)}>
                Confirm
              </Button>
            )}
            {(payErrorType === 100) && (
              <Button style={{ marginLeft: '20px', fontSize: '16px', fontWeight: '800', backgroundColor: '#76b452', color: '#fff', borderRadius: '8px', padding: '10px 50px', boxShadow: '0px 4px 8px rgba(0,0,0,0.5)', textTransform: 'none' }} onClick={this.toRecharge.bind(this)}>
                Confirm
              </Button>
            )}
          </DialogActions>
        </BootstrapDialog>
        {payErrorType === 0 && dialogResultOpen && <PromptDialog
          dialogOpen={dialogResultOpen}
          level="success"
          title="<span style='color: #4caf50; font-size: 24px; font-weight: bold'>Payment successful!</span>"
          content={`
            <div style="text-align: center; padding: 10px 15px">
              <div style="margin-bottom: 15px; font-size: 16px">
                <span style="font-weight: 500">Thank you for your purchase!</span>
              </div>
              <div style="margin-bottom: 15px; font-size: 15px; line-height: 1.5">
                Your CDKey will be sent to <span style="color: #2196f3; font-weight: 500">${sendEmail}</span> shortly.
              </div>
              ${paymentMethod === 'stripe' ? `<div style="font-size: 14px; color: #757575; font-style: italic; padding: 0 20px">
                Please note that some payments may require additional verification before delivery.
              </div>`: ''}
            </div>`}
          cancelAction={this.handleResultClose}
          cancelButtonName="Close"
        />}
        {payErrorType === -1 && dialogResultOpen && <PromptDialog dialogOpen={dialogResultOpen} level="failure" title="Failure to payment." content={`The amount in your NOIZ wallet is abnormal<br/>Please contact us at support@noiz.gg`} cancelAction={this.handleResultClose} />}
        {payErrorType === 1 && dialogResultOpen && !this.state.errorText && <PromptDialog dialogOpen={dialogResultOpen} level="success" title="Do you want to redirect to the payment page to complete the payment?" content={''} confirmButtonName="Make Payment" confirmAction={this.payPaypalOrder} cancelButtonName='cancel' cancelAction={this.handleResultClose} />}
        {payErrorType === 1 && dialogResultOpen && this.state.errorText && <PromptDialog
          dialogOpen={dialogResultOpen}
          level="error"
          title="<span style='color: #f44336; font-size: 20px; font-weight: bold'>Payment Failed</span>"
          content={`
            <div style="text-align: center; padding: 10px 15px">
              <div style="margin-bottom: 15px; font-size: 16px; color: #f44336;">
                <span style="font-weight: 500">There was a problem with your payment</span>
              </div>
              <div style="margin-bottom: 15px; font-size: 15px; line-height: 1.5">
                ${this.state.errorText}
              </div>
              <div style="font-size: 14px; color: #757575; font-style: italic; padding: 0 20px">
                Please try again with another payment method or contact support if the problem persists.
              </div>
            </div>
          `}
          cancelAction={this.handleResultClose}
          cancelButtonName="Close"
        />}
        {payErrorType === 2 && dialogResultOpen && <PromptDialog dialogOpen={dialogResultOpen} level="warn" title="NOIZ wallet has insufficient balance" content={'The balance in your Noiz account in insufficient.'} cancelAction={this.handleResultClose} />}
        {dialogPayOpen && <OrderConfirmDialog dialogOpen={dialogPayOpen} curOrder={curOrder} paymentMethod={paymentMethod} button1Action={this.handlePayClose} button1Name="Cancel" button2Action={this.payOrder} button2Name="Make Payment" payType={this.state.paymentMethod} />}
      </section>
    );
  }
}

GameNew.propTypes = {
  // router: PropTypes.shape({
  //   replace: PropTypes.func.isRequired,
  // }).isRequired,
};

export default GameNew;
